<template>
	<div class="vignette">
		<img :src="game_config.ui_vignette_corner" />
		<img :src="game_config.ui_vignette_corner" />
		<img :src="game_config.ui_vignette_corner" />
		<img :src="game_config.ui_vignette_corner" />
	</div>
</template>

<script>
import { mapState } from 'vuex';
import msEdgeImageSwap from '@/mixins/msEdgeImageSwap';

export default {
	name: 'Vignette',
	mixins: [msEdgeImageSwap],
	computed: {
		...mapState({ // get data from wordpress Game Config page
			game_config: state => state.config.data.game_config,
		}),
	},
	mounted() {
		this.swapEdgeImages();
	},
};
</script>

<style lang="scss">
.vignette{
	width: 100%;
	height: 100%;
	pointer-events: none;
	position: fixed;
	top: 0;
	left: 0;
	display: flex;
	flex-wrap: wrap;
	-webkit-filter: blur(0px);
	& img{
		width: 35%;
		&:nth-child(2){
			margin-left: auto;
			transform: scaleX(-1);
		}
		&:nth-child(3){
			margin-top: auto;
			transform: scaleY(-1);
		}
		&:nth-child(4){
			margin-left: auto;
			margin-top: auto;
			transform: scale(-1, -1);
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/abstract/Vignette.vue